<template>
  <div>
    <photo-selection-group
      v-for="optionProduct in optionProducts"
      :key="optionProduct.CatalogPackageOptionProductID"
      :option-product="optionProduct"
    />
    <photo-selection-form-inputs />
  </div>
</template>

<script>
import PhotoSelectionGroup from './Group'
import PhotoSelectionFormInputs from './FormInputs'

export default {
  name: 'MixAndMatchPhotoSelection',
  components: {
    PhotoSelectionGroup,
    PhotoSelectionFormInputs
  },
  props: {
    optionProducts: { type: Array, default: function () { return [] } }
  },
  created () {
    this.$store.commit('initMixMatchSelections', this.optionProducts)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// WebResources/vue/default/catalog-mix/components/PhotoSelection/PhotoSelection.vue